import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GeneralCatalogViewModel } from 'src/app/model/general/general-catalog.view';

@Component({
  selector: 'ms-consult-catalog-item',
  templateUrl: './item.component.html',
})
export class GeneralConsultCatalogItemComponent {
  @Input() readonly = false;
  @Input() catalog: GeneralCatalogViewModel = {};
  @Output() catalogChange: EventEmitter<GeneralCatalogViewModel> =
    new EventEmitter();

  handleChange = (isChekbox: boolean = false) => {
    if (isChekbox) {
      delete this.catalog.details;
    }
    this.catalogChange.emit(this.catalog);
  };

  handleLabelClick = () => {
    if (!this.catalog.catalog) {
      this.catalog.filled = !this.catalog.filled;
      this.handleChange(true);
    }
  };
}
